import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosConsultaCreditosMixin = {
  computed: {
    permisosConsultaCreditos() {
      return {
        accesoModulo: tienePermiso('consultarCreditos'),
      };
    },
  },
};
